'use client';
import Link from 'next/link';
import { ArrowLeft, Mail } from 'lucide-react';

const HELP_TOPICS = [
  { title: 'Getting Started', desc: 'Learn how to register as an agent, set up your dashboard, and place your first order.' },
  { title: 'Orders & Delivery', desc: 'Understand how orders are processed, delivery timelines, and how to track your order status.' },
  { title: 'Payments & Wallet', desc: 'Learn about commissions, wallet withdrawals, and payment processing timelines.' },
  { title: 'Referral Program', desc: 'How to share your referral link, track referrals, and earn 15% commission on referred orders.' },
  { title: 'Account & Profile', desc: 'Manage your profile, update your details, and keep your account secure.' },
  { title: 'Technical Issues', desc: 'Troubleshoot login problems, dashboard errors, and other technical difficulties.' },
];

export default function HelpCentrePage() {
  return (
    <div className="min-h-screen bg-white text-[#0f172a]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#1a56ff] mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <h1 className="text-3xl sm:text-4xl font-bold mb-3">Help Centre</h1>
        <p className="text-slate-500 text-sm mb-10">Find answers to common questions and get the support you need.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
          {HELP_TOPICS?.map((topic) => (
            <div key={topic?.title} className="bg-slate-50 rounded-2xl p-5 border border-slate-100">
              <h3 className="text-sm font-bold text-[#0f172a] mb-1.5">{topic?.title}</h3>
              <p className="text-xs text-slate-500 leading-relaxed">{topic?.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-[#0f172a] rounded-2xl p-7 text-white">
          <h2 className="text-base font-bold mb-2">Still need help?</h2>
          <p className="text-sm text-slate-400 mb-5">Our support team is available Mon–Sat, 10am–7pm IST.</p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a href="mailto:support@dropservice.in" className="inline-flex items-center gap-2 bg-[#1a56ff] text-white text-sm font-semibold px-4 py-2.5 rounded-xl hover:bg-[#1648d4] transition-colors">
              <Mail size={15} /> Email Support
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
